import React, { FC } from 'react';
import { Modal, ModalSize, ModalClose, Text, ModalFooter, Box, Spinner } from '@bechtel/gds';
import { ModalHeaderStyled, ModalSubHeader, ModalBodyStyled, ModalFooterButtonStyled } from './styled';
import { useCommodity } from '~/detail/commodities/context';
import { t, Trans } from '@lingui/macro';

export interface ConfirmClaimActionProps {
  onCertifyClick: () => void;
  isMutationInProgress: boolean;
  close: () => void;
}

export const ConfirmClaimAction: FC<ConfirmClaimActionProps> = ({ onCertifyClick, isMutationInProgress, close }) => {
  const { tag, typeName } = useCommodity();
  return (
    <Modal visible size={ModalSize.LARGE}>
      <ModalHeaderStyled title={t`Complete Verification`}>
        <ModalClose onClick={close} />
      </ModalHeaderStyled>
      <ModalSubHeader>
        <Text family="graphik" size="500" color="grey.1000" weight="600">
          {typeName}: {tag}
        </Text>
      </ModalSubHeader>
      <ModalBodyStyled>
        <Box px={{ sm: '500' }} pt={{ sm: '700' }} pb={{ sm: '800' }}>
          <Text size="500" family="graphik" color="grey.1000">
            <Trans>
              I certify that piping internal cleanliness was acceptable <br /> prior to completing all piping
              connections.
            </Trans>
          </Text>
        </Box>
      </ModalBodyStyled>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <ModalFooterButtonStyled onClick={close} disabled={isMutationInProgress}>
              <Trans> Cancel</Trans>
            </ModalFooterButtonStyled>
          </Box>
          <Box>
            <ModalFooterButtonStyled type="submit" onClick={onCertifyClick} disabled={isMutationInProgress}>
              {!isMutationInProgress && <Trans>Certify</Trans>}
              {isMutationInProgress && <Spinner></Spinner>}
            </ModalFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
